import { LABELS } from '@/constants/common/message.constants'

import type { AdditionalPaymentCategoryEntity } from '../../aspida/@types'

/**
 *
 * 追加支払運賃の利用タイプ
 */
export type ReportType = AdditionalPaymentCategoryEntity['reportType']

export const REPORT_TYPE = {
  /** 日次 */
  DAILY: 'DAILY',
  /** 月次 */
  MONTHLY: 'MONTHLY'
} as const satisfies Record<ReportType, ReportType>
export const REPORT_TYPE_LABEL = {
  [REPORT_TYPE.DAILY]: LABELS.DAILY,
  [REPORT_TYPE.MONTHLY]: LABELS.MONTHLY
} as const satisfies Record<ReportType, string>
